import { AxiosError, AxiosInstance, AxiosResponse } from 'axios'
import { useQuery } from 'react-query'
import type { RequestRole } from '../lib/withDiaperBankAuthentication'
import { DiaperBankPublic } from './DiaperBankDTO'

export function useDiaperBank({
  apiClient,
  slug,
  enabled,
  onError,
  onSuccess,
  role,
}: {
  apiClient: AxiosInstance
  slug?: string
  enabled?: boolean
  onError?: (error: AxiosError) => void
  onSuccess?: (data: AxiosResponse<DiaperBankPublic> | undefined) => void
  /** Indicate to react-query's caching logic whether this request requires the public or admin version of the diaper bank */
  role: RequestRole
}) {
  return useQuery<AxiosResponse<DiaperBankPublic> | undefined, AxiosError>(
    ['diaperBank', slug, role],
    () => (slug ? apiClient.get<DiaperBankPublic>(`diaperBanks/${slug}`) : undefined),
    {
      enabled,
      onError,
      // disable react-query's silly default behavior of retrying on 404
      retry: (_, error) => {
        if (!error.response) return true
        return error.response.status !== 404
      },
      onSuccess,
    },
  )
}
